var _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParticipants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "participants",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19255",
    "data-name": "Gruppe 19255",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284043",
    "data-name": "Pfad 284043",
    d: "M22,25.075A4.075,4.075,0,1,1,26.075,21,4.08,4.08,0,0,1,22,25.075Zm0-7A2.925,2.925,0,1,0,24.925,21,2.928,2.928,0,0,0,22,18.075Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19256",
    "data-name": "Gruppe 19256",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284044",
    "data-name": "Pfad 284044",
    d: "M29.5,35.075a.576.576,0,0,1-.575-.575V34c0-3.423-3.236-6.425-6.925-6.425s-6.925,3-6.925,6.425v.5a.575.575,0,1,1-1.15,0V34c0-4.035,3.773-7.575,8.075-7.575s8.075,3.54,8.075,7.575v.5A.576.576,0,0,1,29.5,35.075Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19257",
    "data-name": "Gruppe 19257",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284045",
    "data-name": "Pfad 284045",
    d: "M28.425,24.075c-.262,0-.628-.035-.792-.054a.575.575,0,0,1,.134-1.142,6.346,6.346,0,0,0,.658.046,2.925,2.925,0,1,0-1.507-5.433.575.575,0,1,1-.594-.984,4.075,4.075,0,1,1,2.1,7.567Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19258",
    "data-name": "Gruppe 19258",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284046",
    "data-name": "Pfad 284046",
    d: "M35.5,34.075a.576.576,0,0,1-.575-.575v-.8A6.364,6.364,0,0,0,28.5,26.575a7.412,7.412,0,0,0-.924.085.575.575,0,1,1-.152-1.14,8.4,8.4,0,0,1,1.076-.1A7.53,7.53,0,0,1,36.075,32.7v.8A.576.576,0,0,1,35.5,34.075Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19259",
    "data-name": "Gruppe 19259",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24677",
    "data-name": "Rechteck 24677",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.3f2c8849eaf47d1962d256f3422f97f8.svg";
export { ForwardRef as ReactComponent };